import React, { FC } from 'react';
import styled from 'styled-components';

type PageIconsProps = {
  PrimaryIcon: any;
  SecondaryIcon?: any;
  color?: string;
};

export const PageIcons: FC<PageIconsProps> = ({
  PrimaryIcon,
  SecondaryIcon,
  color = '#202733',
}) => {
  return (
    <IconWrapper>
      <div className="primary-icon">
        <PrimaryIcon color={color} size="l" />
      </div>
      {SecondaryIcon && (
        <div className="secondary-icon">
          <SecondaryIcon color={color} size="l" />
        </div>
      )}
    </IconWrapper>
  );
};

export const IconWrapperSize = 120;
const DotSize = 60;
const IconWrapper = styled.div`
  position: relative;
  height: ${IconWrapperSize}px;
  width: ${IconWrapperSize}px;
  min-width: ${IconWrapperSize}px;
  margin-right: 22px;
  &::before {
    display: block;
    border-radius: 50%;
    width: ${DotSize}px;
    height: ${DotSize}px;
    content: '';
    margin-left: calc(${IconWrapperSize}px / 2 - ${DotSize}px / 2);
    margin-top: calc(${IconWrapperSize}px / 2 - ${DotSize}px / 2);
    background-color: #99e0d6;
  }

  .primary-icon {
    position: absolute;
    top: 0;
    left: 0;
    transition: top 0.2s ease-in;

    svg {
      width: 54px;
    }
  }
  .secondary-icon {
    position: absolute;
    bottom: 0;
    right: 0;
    transition: bottom 0.2s ease-in;

    svg {
      width: 54px;
    }
  }
`;
